//员工花名册
import { $http, buildHeaders } from "./index";

//获取员工列表
export const employee_list = (params) => {
  return $http.get("/admin/Employee/index", { params });
};

//获取员工详情
export const employee_detail = (id) => {
  return $http.get("/admin/Employee/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取员工基本信息
export const employee_info = (id) => {
  return $http.get("/admin/Employee/info?id=" + id, {
    headers: buildHeaders(3),
  });
};

//下载员工表模板
export const employee_download = () => {
  return $http.get("/admin/Employee/download", {
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//导入员工
export const employee_import = (data) => {
  let headers = buildHeaders(1, "员工表格数据解析中，请稍后……");
  headers["Content-Type"] = "multipart/form-data";
  return $http.post("/admin/Employee/import", data, {
    headers,
  });
};

//添加员工
export const employee_add = (data) => {
  return $http.post("/admin/Employee/add", data, {
    headers: buildHeaders(3),
  });
};

//修改员工
export const employee_edit = (data) => {
  return $http.post("/admin/Employee/edit", data, {
    headers: buildHeaders(3),
  });
};

//导出员工表
export const employee_export = (params) => {
  return $http.get("/admin/Employee/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//删除员工
export const employee_delete = (id) => {
  return $http.post(
    "/admin/Employee/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取申报单位列表
export const employee_applicationunit_list = (params) => {
  return $http.get("/admin/ApplicationUnit/index", { params });
};

//获取申报单位详情
export const employee_applicationunit_detail = (id) => {
  return $http.get("/admin/ApplicationUnit/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//添加申报单位
export const employee_applicationunit_add = (data) => {
  return $http.post("/admin/ApplicationUnit/add", data, {
    headers: buildHeaders(3),
  });
};

//修改申报单位
export const employee_applicationunit_edit = (data) => {
  return $http.post("/admin/ApplicationUnit/edit", data, {
    headers: buildHeaders(3),
  });
};

//删除申报单位
export const employee_applicationunit_delete = (id) => {
  return $http.post(
    "/admin/ApplicationUnit/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};

//获取发薪单列表
export const employee_salaryrecord = (params) => {
  return $http.get("/admin/Employee/salaryRecord", { params });
};

//获取发薪单详情
export const employee_salaryrecord_detail = (params) => {
  return $http.get("/admin/Employee/salaryRecordDetail", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取算税单列表
export const employee_calctax = (params) => {
  return $http.get("/admin/Employee/calcTax", { params });
};

//删除员工附件
export const employee_attachment_delete = (data) => {
  return $http.post("/admin/Employee/delAttachment", data, {
    headers: buildHeaders(3),
  });
};

//获取员工专项扣除记录
export const employee_essential_list = (params) => {
  return $http.get("/admin/Employee/essential", { params });
};
